import { render } from "./NewsFeed.vue?vue&type=template&id=6c22b3b2&scoped=true"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"

import "./NewsFeed.vue?vue&type=style&index=0&id=6c22b3b2&scoped=true&lang=css"
import "./NewsFeed.vue?vue&type=style&index=1&id=6c22b3b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c22b3b2"]])

export default __exports__